module.exports = __webpack_public_path__ + "entry-41b28522/airbus-photo-16dda3c15b690a286a667a7c78cd07ae.webp";